import { type FC, type ReactNode, useReducer } from "react";

import { FocusContext, FocusContextInitialState, FocusContextReducer } from "./FocusContext";

/**
 * FocusContextProvider
 * keeps track of shared DOM elements to enable .focus() methods
 */
export const FocusContextProvider: FC<{ children?: ReactNode }> = ({ children }) => {
	const [state, dispatch] = useReducer(FocusContextReducer, FocusContextInitialState);
	return <FocusContext.Provider value={{ state, dispatch }}>{children}</FocusContext.Provider>;
};
